import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled/macro';
import vars from '../variables';

export interface SectionLayoutProps {
  displaySeparator?: boolean;
  className?: string;
  isContentHub?: boolean;
  isCSI?: boolean;
  isDottedLine?: boolean;
}

const SectionLayout: React.FC<PropsWithChildren<SectionLayoutProps>> = ({
  displaySeparator = false,
  children,
  className,
  isDottedLine,
}) => {
  return (
    <section className={className}>
      {displaySeparator && <div className="separator" />}
      <div className="section-container">{children}</div>
    </section>
  );
};

const StyledSectionLayout = styled(SectionLayout)<{ isDottedLine?: boolean }>`
  &:first-of-type .separator {
    display: none;
  }
  .separator {
    height: 1px;
    margin: ${vars.spacingM} 0;
    @media screen and (min-width: ${vars.breakPointFullWidth}) {
      margin: ${vars.spacingXl} 0 ${vars.spacingL} 0;
      ${({ isDottedLine }) =>
        isDottedLine ?? true
          ? `height: 0; border-top: 1px dashed ${vars.borderGrey};`
          : `height: 1px;`}
    }
  }
  .section-container {
    max-width: ${({ isContentHub }) => {
      if (isContentHub) return '100%';
      return vars.contentMaxWidth;
    }};
    margin: 0 auto;
  }
`;

export default StyledSectionLayout;
